(() => {
  const reveal = () => {
    const items = document.querySelectorAll('[data-lp-reveal]:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((item) => observer.observe(item));
  };

  const sliders = () => {
    document.querySelectorAll('.lp-slider-shell').forEach((shell) => {
      const track = shell.querySelector('[data-lp-slider]');
      const previous = shell.querySelector('[data-lp-slider-prev]');
      const next = shell.querySelector('[data-lp-slider-next]');
      const section = shell.closest('.lp-category-slider');
      const counter = section?.querySelector('[data-lp-slider-counter]');
      const progress = section?.querySelector('[data-lp-slider-progress]');
      if (!track) return;
      const cards = Array.from(track.children);
      const update = () => {
        const left = track.scrollLeft;
        const current = cards.reduce((closest, card, index) => {
          const distance = Math.abs(card.offsetLeft - left);
          return distance < closest.distance ? { index, distance } : closest;
        }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
        const total = cards.length || 1;
        if (counter) counter.textContent = `${String(current + 1).padStart(2, '0')} / ${String(total).padStart(2, '0')}`;
        if (progress) progress.style.transform = `scaleX(${(current + 1) / total})`;
      };
      const move = (direction) => {
        const width = cards[0]?.getBoundingClientRect().width || track.clientWidth * 0.72;
        track.scrollBy({ left: width * direction, behavior: 'smooth' });
      };
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  };

  const desktopMenus = () => {
    const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    document.querySelectorAll('.lp-header-showcase-menu').forEach((menu) => {
      if (menu.dataset.lpHoverReady === 'true') return;
      menu.dataset.lpHoverReady = 'true';
      let closeTimer;
      const openMenu = () => {
        window.clearTimeout(closeTimer);
        if (supportsHover.matches) menu.open = true;
      };
      const closeMenu = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (supportsHover.matches && !menu.matches(':hover') && !menu.contains(document.activeElement)) menu.open = false;
        }, 420);
      };
      menu.addEventListener('pointerenter', openMenu);
      menu.addEventListener('pointerleave', closeMenu);
      menu.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!menu.contains(document.activeElement)) menu.open = false;
        }, 180);
      });
    });
  };

  const mobileSearch = () => {
    document.querySelectorAll('[data-lp-search-trigger]').forEach((trigger) => {
      if (trigger.dataset.lpSearchReady === 'true') return;
      trigger.dataset.lpSearchReady = 'true';
      trigger.addEventListener('click', (event) => {
        const searchToggle = document.querySelector('details-modal.header__search summary');
        if (!searchToggle) return;
        event.preventDefault();
        event.stopPropagation();
        searchToggle.click();
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => { reveal(); sliders(); desktopMenus(); mobileSearch(); });
  document.addEventListener('shopify:section:load', () => { reveal(); sliders(); desktopMenus(); mobileSearch(); });
})();
